export const getBuNameById = (buId, buOptions = []) => {
  const emailBuOption = buOptions.find(({
    id
  }) => id === buId);
  const buName = emailBuOption ? emailBuOption.name : '';
  return buName;
};